var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"empty",style:({ height: _vm.emptyHeight + 'px' })},[_c('img',{staticClass:"emptyImg",attrs:{"src":_vm.imageSrc,"alt":""}}),_c('p',{staticClass:"emptyText"},[_vm._v(_vm._s(_vm.text))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }